import type { ReactNode } from 'react';

export const symbol_magnification_large: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M224-368h421q12.75 0 21.38-8.63Q675-385.25 675-398v-258q0-12.75-8.62-21.38Q657.75-686 645-686H224q-12.75 0-21.37 8.62Q194-668.75 194-656v258q0 12.75 8.63 21.37Q211.25-368 224-368Zm-84 208q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
